exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-text[data-v-67f754ca] {\n  height: 55px;\n  overflow-y: scroll;\n}\n.category-item[data-v-67f754ca] {\n  padding: 9px;\n}\n.enabled.category-item[data-v-67f754ca] {\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n.category-item[data-v-67f754ca] {\n    padding: 2.5px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67f754ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/service/campaignManager/CampaignCategory.vue
// module id = PrKa
// module chunks = 53